import React from 'react';
import { SvgIcon } from '@mui/material';
import styles from './iconStyles';

function SearchAndBuy() {
  return (
    <SvgIcon style={styles.icon}>
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <title>Marketplace</title>
        <desc>Created with Sketch.</desc>
        <g id="Search-and-buy" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="basket-search-copy" fillRule="nonzero">
            <path
              d="M9.496,0.132 C9.94078571,0.386428571 10.116551,0.931433673 9.9200113,1.39150765 L9.868,1.496 L7.294,6 L16.705,6 L14.132,1.496 C13.858,1.017 14.025,0.405 14.504,0.132 C14.9487857,-0.122428571 15.50825,0.00339285714 15.8044832,0.406179665 L15.868,0.504 L19.009,6 L23,6 C23.5125714,6 23.9354694,6.38542347 23.9932682,6.88324672 L24,7 L24.0002872,13.4012411 C22.6305286,11.9243072 20.673206,11 18.5,11 C14.3578644,11 11,14.3578644 11,18.5 C11,20.1886276 11.5580618,21.7469128 12.4998166,23.0004871 L3,23 C2.48742857,23 2.06453061,22.6145765 2.00673178,22.1167533 L2,22 L2,11 L1,11 C0.487428571,11 0.0645306122,10.6145765 0.00673177843,10.1167533 L-1.95399252e-14,10 L-1.95399252e-14,7 C-1.95399252e-14,6.4865 0.386285714,6.06439796 0.883431487,6.00671757 L1,6 L4.991,6 L8.132,0.504 C8.406,0.025 9.017,-0.142 9.496,0.132 Z"
              id="Combined-Shape"
              fill="#4E4F57"
            />
            <path
              d="M22,18 C22,15.794 20.206,14 18,14 C15.794,14 14,15.794 14,18 C14,20.206 15.794,22 18,22 C18.74,22 19.424,21.785 20.019,21.433 L22.293,23.707 L23.707,22.293 L21.433,20.019 C21.785,19.424 22,18.74 22,18 Z M18,20 C16.897,20 16,19.103 16,18 C16,16.897 16.897,16 18,16 C19.103,16 20,16.897 20,18 C20,19.103 19.103,20 18,20 Z"
              id="Shape"
              fill="#A6A7AB"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}

export default SearchAndBuy;